import toast from "react-hot-toast";
import { http } from "../../Utility/APIRequest";
import { FetchIDError, FetchIDStart, FetchIDSuccess } from "./VehicleSlice";
import { HandleHTTPRequestError } from "../../Utility/HandleHTTPRequestError";
import { t } from "i18next";

export const FetchRecordID = (token, id) => async (dispatch) => {
  dispatch(FetchIDStart());
  // http request to backend
  try {
    const response = await http.get(`api/driver/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toast.success(t("toast.data_fetch"));
    dispatch(FetchIDSuccess(response.data.record));
  } catch (error) {
    dispatch(FetchIDError());
    if (error.response) {
      HandleHTTPRequestError(error.response.status, error, dispatch);
    } else {
      // Handle the case where the API is offline or unreachable
      console.error("API is offline or unreachable.");
        toast.error(t("toast.apiOffline"));
    }
  }
};
